// removed by extract-text-webpack-plugin
module.exports = {"IdWrapper":"IdWrapper__IdWrapper___3YxoH","IdWrapperSlug":"IdWrapper__IdWrapperSlug___2PAUa","IdWrapperSlugStandalone":"IdWrapper__IdWrapperSlugStandalone___1uJj_"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/IdWrapper/IdWrapper.less
// module id = 1268
// module chunks = 0 1